<template lang="pug">
  .custom-container
    ListDocuments
</template>

<script>
import { mapGetters } from 'vuex'
import ListDocuments from '../components/home_client/ListDocuments'
export default {
  components:{
    ListDocuments
  }
}
</script>

<style lang="scss" scoped>
.section-title {
  margin-top: 20px;
}
</style>